import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const UserGroupPlaceholderIcon = createIcon({
    viewBox: '0 0 76 62',
    path: (
        <>
            <Path
                fill='currentColor'
                fillRule='evenodd'
                d='M9 56h48v-3.238a3.698 3.698 0 0 0-2.135-3.333l-14.373-6.714a2.643 2.643 0 0 1-1.527-2.153 2.593 2.593 0 0 1 1.054-2.365c3.021-2.22 4.754-5.628 4.754-9.347V17.097c0-2.09-.914-4.073-2.508-5.441C39.479 9.265 36.274 8 33 8c-3.274 0-6.478 1.265-9.264 3.656a7.166 7.166 0 0 0-2.508 5.441V28.85c0 3.719 1.733 7.127 4.754 9.348a2.59 2.59 0 0 1 1.054 2.364 2.643 2.643 0 0 1-1.527 2.153l-14.373 6.714A3.699 3.699 0 0 0 9 52.762V56zm50 2H7v-5.238a5.707 5.707 0 0 1 3.29-5.146l14.373-6.714a.65.65 0 0 0 .383-.537.591.591 0 0 0-.247-.554c-3.488-2.565-5.571-6.663-5.571-10.961V17.097a9.16 9.16 0 0 1 3.206-6.958C25.588 7.431 29.241 6 33 6c3.759 0 7.413 1.431 10.567 4.139a9.163 9.163 0 0 1 3.206 6.958V28.85c0 4.298-2.083 8.396-5.571 10.96a.594.594 0 0 0-.247.555.65.65 0 0 0 .383.537l14.373 6.714A5.708 5.708 0 0 1 59 52.762V58z'
            />
            <Path
                fill='currentColor'
                fillRule='evenodd'
                d='M64.88 43.62L50.5 36.91a.664.664 0 0 1-.38-.54c-.01-.13 0-.38.25-.56 3.49-2.56 5.57-6.66 5.57-10.96V13.1c0-2.67-1.17-5.21-3.21-6.96C49.58 3.43 45.93 2 42.17 2c-2.74 0-5.42.76-7.89 2.22 1.14.09 2.25.29 3.35.6 1.47-.54 3-.82 4.54-.82 3.27 0 6.48 1.27 9.26 3.66a7.148 7.148 0 0 1 2.51 5.44v11.75c0 3.72-1.73 7.13-4.75 9.35a2.582 2.582 0 0 0-1.06 2.36c.09.95.67 1.75 1.53 2.16l14.37 6.71c1.3.61 2.14 1.92 2.14 3.33V52h-5.23c.04.31.06.62.06.93V54h7.17v-5.24c0-2.19-1.29-4.21-3.29-5.14'
            />
        </>
    ),
})

UserGroupPlaceholderIcon.displayName = 'UserGroupPlaceholderIcon'
